export const DIARY_SLOT_SEARCH_REQUEST = "DIARY_SLOT_SEARCH_REQUEST";
export const DIARY_SLOT_SEARCH_SUCCESS = "DIARY_SLOT_SEARCH_SUCCESS";
export const DIARY_SLOT_SEARCH_FAIL    = "DIARY_SLOT_SEARCH_FAIL";

export const DIARY_SLOT_CHECK_AVAILABILITY_REQUEST = "DIARY_SLOT_CHECK_AVAILABILITY_REQUEST";
export const DIARY_SLOT_CHECK_AVAILABILITY_SUCCESS = "DIARY_SLOT_CHECK_AVAILABILITY_SUCCESS";
export const DIARY_SLOT_CHECK_AVAILABILITY_FAIL    = "DIARY_SLOT_CHECK_AVAILABILITY_FAIL";

//Task 24646 - moving a slot by dragging it on the board
export const DIARY_SLOT_UPDATE_REQUEST = "DIARY_SLOT_UPDATE_REQUEST";
export const DIARY_SLOT_UPDATE_SUCCESS = "DIARY_SLOT_UPDATE_SUCCESS";
export const DIARY_SLOT_UPDATE_FAIL    = "DIARY_SLOT_UPDATE_FAIL";

export const DIARY_SLOT_BOOK_REQUEST = "DIARY_SLOT_BOOK_REQUEST";
export const DIARY_SLOT_BOOK_SUCCESS = "DIARY_SLOT_BOOK_SUCCESS";
export const DIARY_SLOT_BOOK_FAIL    = "DIARY_SLOT_BOOK_FAIL";
